export default {
    translation: {
		actions: '동작',
		angle: '각도',
        appName: 'GolanixMRT',
		backgroundColor: '배경색',
		backToHomepage: '기본화면으로 돌아가기',
		blockProperties: '속성 막기',
		blueTooth: '블루투스',
		checkAnswer: '정답 확인',
		checkEmailBox: '이메일 확인',
		color: '색',
		communication: '통신',
		confirmPassword: '비밀번호 확인',
		connect: '연결',
		connected: '연결됨',
		correctlyAnswer: '정확히 답해주세요',
		courseImage: '코스 사진',
		course: '코스',
		description: '설명',
		devicesList: '기기 목록',
		direction: '방향',
		disconnect: '연결 끊기',
		downloadToRobot: '로봇으로 다운로드',
		doYouWantSave: '새로운 문서를 작성하기 전에 저장하시겠습니까?',
		email: '이메일',
		emailAlreadyExists: '이미 존재하는 이메일 주소 입니다.',
		emailHassBeenSent: '이메일이 정상적으로 보내졌습니다.',
		emailHasNotBeenSent: '이메일을 전송하는데 실패하였습니다.',
		en: 'English',
		zh: '중국어',
		kr: '한국어',
		error: '오류',
		files: '문서',
		finished: '완료',
		finishTopic: '주제 완료',
		forgotPassword: '암호를 잊으셨습니까?',
		he: '히브리어',
		help: '도움',
		home: '홈',
		homepage: '홈페이지',
		id: '아이디',
		image: '이미지',
		language: '언어',
		languageDoYouWantSave: '언어를 바꿀시 프로젝트가 초기화 됩니다. 저장하시겠습니까?',
		lessons: '수업',
		lesson_image: '수업 사진',
		level: '단계',
		level1: '초급',
		level2: '중급',
		level3: '고급',
		level4: '전문가',
		level5: '숙련가',
		list:'목록',
		login: '로그인',
		logout: '로그아웃',
		name: '이름',
		no: '아니오',
		notFoundText: '페이지를 찾을 수 없습니다.',
		notFoundTitle: '404에러 : 페이지를 찾을수 없습니다',
		notStarted: '시작 안함',
		numberOfDaysBeforeLesson: '개강전남은일수',
		online: '온라인',
		openOurSite: '사이트를 여십시오',
		password: '암호',
		passwordHasBeenChanged: '암호가 정상적으로 바뀌었습니다',
		port: '포트',
		prerequisiteCourses: '선수 과정',
		profile: '프로필',
		register: '등록',
		resetFilters: '필터 재설정',
		resetPassword: '암호 재설정',
		saveResult: '결과 저장',
		scanDevices: '기기 스캔',
		search: '검색',
		searchFor: '검색할것',
		sendPasswordResetLink: '암호 초기화 링크를 전송합니다',
		settings: '설정',
		siteMessage: '사이트 메세지',
		sound: '소리',
		sourceCode: '소스 코드',
		speed: '속도',
		started: '시작',
		status: '상태',
		success: '성공',
		terminal: '터미널',
		topic: '주제',
		topicContent: '주제 내용',
		topicImage: '주제 사진',
		topicQuizzes: '주제 퀴즈',
		topics: '주제',
		topicVideo: '주제 영상',
		tryAgain:'다시 시도',
		updateSystem: '시스템 업데이트',
		usb: 'USB',
		userNotExistCredentials: '사용자가 존재 하지 않습니다',
		workspace: '작업 공간',
		yes: '예',
		youDidNotPassTheQuizzes: '퀴즈를 통과하지 못했습니다.',
		youSpentLittleTimeWatchingContent: '영상 시청 시간이 부족합니다',
		version: '버전',
        //MainPage
		mainPageTitleOnlineRobotic: '%를 위한 온라인 코딩 코스',
		mainPageTitleAdventurersKids: '모험가 아이들',
		mainPageButtonCoursesList: '코스 목록',
		mainPageButtonSignInUp: '서명 | 등록',
		mainPageContentTitle: '우리의 모험',
		buttonStartAdventure: '모험 시작',
		paginationShowMore: '더보기',
		programMyRobot: '내 로봇 프로그래밍',
        //Pop-up
		notification: '알림',
		newBadge: '배지',
		youReceivedANewBadge: '새 배지를 받았습니다.',
		newCertificate: '새로운 인증서',
		youReceivedANewCertificate: '새 인증서을 받았습니다.',
		selectPicture: '사진 선택',
		apply: '적용',
		uploadPicture: '사진 업로드',
		signIn: '서명',
		forgotMyPassword: '암호를 잊버렸습니다',
		doNotHaveAccount: '계정이 없으신가요?',
		myProfile: '내 프로필',
		about: '더보기',
		back: '뒤로가기',
		signOut: '로그아웃',
		passwordRecovery: '암호 복구',
		passwordReset: '암호 재설정',
		userName: '사용자 이름',
		yourEmail: '이메일 주소',
		signUp: '등록',
		notInternet: '인터넷 연결 안됨',
		connectToInternet: '인터넷 연결',
		passwordConfirmation: '암호 확인',
        //lessonsPage
		btnContinue:'이어서 하기',
		whatWillLearn: '나는 무엇을 배울까',
		join: '합류하다',
		hours: '시간',
		graduated: '등급',
		video: '비디오',
		developingSkills: '개발기술',
		courseBadges: '코스 배지',
		moreAdventureCourses: '더 많은 모험 코스들',
		learnMoreRobots: '더 많은 로봇에 대해 배우기',
		news: '뉴스',
        //dashboard
		activeCourses: 'Active Courses',
		courseCompleted: '코스 완료',
		lessonsCompleted: '레슨 완료',
		skillsAcquired: '기술 습득',
		badges: '배지',
		certificates: '인증서',
		moreAdventurersForYou: '더 많은 모험',
        //topic
		filesAndTools: '파일과 도구',
		yourMission: '당신의 미션',
		quiz: '퀴즈',
		launchProgram: '실행 프로그램',
		complete: '완료',
		sendAnswers: '정답 보내기',
		wrongQuizAnswer: '틀린 답이 있습니다. 다시 확인해주세요.',
		correctQuizAnswer: '참잘했어요.',
		quizPassed: '퀴즈 합격',
		welcome: '환영합니다',
		guest: '손님',
		willBeAvailable: '이용할수있습니다',
		willBeAvailableIn: ' %에서 이용할수있읍니다.',
		days: '날',
		unlockLevel:'레벨 해제',
		pleaseInsertThePassword: '암호를 입력하시오',
		submit: '제출',
		close:'닫기',
		invaildPassword: '암호가 유효하지 않습니다. 다시 시도하십시오.',
        robokidsAndventures: 'Robokids Andventures',
		studentDashboard: '학습자 대시보드',
		intTheLessonThereAreNoTopics: '수업에 주제가 없습니다',
		courseMapTitle: '코스 맵',
		iWantProgram: '내 로봇 프로그래밍 하기',
		afterPreviousLessonCompletion: '이전 수업 완료 후',
		rotateYourDevice: '기기를 회전하십시오',
		downloading: '다운로드중',
		errorDownloading: '다운로드중 오류',
		scanningForRobots: '로봇 검색중',
		joyStick:'조이스틱',
		pleaseAnswerTheQuizQuestions: '모든 질문에 답하시오',
        mainPageDescription: 'Golanix offers an adventure combined with learning code. we have large variety of courses for tournaments drives players to take the most desirable actions towards becoming a code.',
        projectDoYouWantSave: 'This action will clear your project. Do you want to save firstly?',
    },
};



// WEBPACK FOOTER //
// ./src/lang/zh/zh.js